<p>{{info[content][lang]}}</p>
<p mat-dialog-content class="code">{{info[content]?.code}}</p>
<div mat-dialog-actions>
  <button i18n="@@GotIt" mat-dialog-close class="btn btn-default">Got it</button>
</div>
